import React from 'react'
import { twMerge } from 'tailwind-merge'

import { textSeparator } from '@ui-kit/components/layoutComponents/TextSeparator/styles'
import { bgColor, borderColor, textColor } from '@ui-kit/styles/colors'
import { marginBottom, marginTop } from '@ui-kit/styles/margin'

import type { Props } from './types'

const TextSeparator = (props: Props) => {
  const { container, line, textContainer, text } = textSeparator()
  return (
    <div
      className={twMerge(
        container(),
        marginTop({ space: props.space }),
        marginBottom({ space: props.space })
      )}
    >
      <div className={textContainer()}>
        <div
          className={line({
            className: borderColor({ color: props.borderColor }),
          })}
        />
        <p
          className={twMerge(
            text(),
            textColor({ color: props.color }),
            bgColor({ color: props.bgColor ?? 'uiGreyLight' })
          )}
        >
          {props.text}
        </p>
      </div>
    </div>
  )
}

export default TextSeparator
